/**
 * Gateway to handle AJAX request/repsonse
 * @param {object} config
 */
function Gateway(config) {
    'use strict';

    this.config = config;
}

Gateway.prototype = {
    /**
     * Http request
     * @param  {Object}   data
     * @param  {Function} callback
     * @param  {String}   method
     * @param  {Function} errorHandler
     * @return {Gateway}
     */
    request: function (data, callback, method, errorHandler) {
        'use strict';

        method = method || 'GET';

        $.ajax({
            url     : this.config.url,
            data    : data,
            dataType: this.config.dataType,
            method  : method
        })
            .done($.proxy(this.handleResponse, this, callback))
            .error(this.handleError.bind(this, errorHandler));

        return this;
    },

    /**
     * Http request
     * @param  {Object}   data
     * @param  {Function} callback
     * @return {Gateway}
     */
    post: function (data, callback) {
        'use strict';

        return this.request(data, callback, 'post');
    },

    jsonpRequest: function (data, callback) {
        'use strict';

        $.ajax({
            url     : this.config.url,
            data    : data,
            dataType: 'jsonp',
            success : callback
        }).done(callback);

        return this;
    },

    /**
     * Response handler
     * @param  {Function} callback
     * @param  {object}   data
     */
    handleResponse: function (callback, data) {
        'use strict';

        if (!callback) {
            return;
        }

        callback(data);
    },

    handleError: function (callback, eventData, handler) {
        'use strict';

        if (callback) {
            callback.call(undefined, eventData, handler);
        }
    }
};

export default Gateway;